const endpoint = process.env.REACT_APP_SERVER_URL || "http://localhost:5000";

export function SubmitData(type: string, data: any) {
    const fetchRoute = endpoint + "/api/data/create";
    const cached: any[] = JSON.parse(localStorage.getItem("cachedData") || "[]") as string[];
    console.log("Sending data: " + JSON.stringify(data))

    const sessionId = [
        type === "match" ? "m" : "p",
        data.team,
        data.match || ""
    ].join("");
    
    const current = {
        type,
        sessionId,
        data: type === "match" ? [
            data.team,
            data.match,
            ...data.data
        ] : [
            data.team,
            ...data.data
        ]
    }
    cached.push(current);

    fetch(fetchRoute, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Version": process.env.REACT_APP_VERSION || "0.0.0"
        },
        body: JSON.stringify(cached)
    }).then((res) => {
            switch (res.status) {
                case 100:
                    window.alert("No data to submit, likely already successfully submitted.");
                    return true;
                case 200:
                    localStorage.setItem("cachedData", "[]");
                    window.alert("Data submitted successfully");
                    return true;
                case 500:
                    localStorage.setItem("cachedData", JSON.stringify(cached));
                    window.alert("Server internal error. Data has been cached and will be submitted later.");
                    return false;
                default:
                    localStorage.setItem("cachedData", JSON.stringify(cached));
                    window.alert("Failed to connect to server or server error. Data has been cached.");
                    return false;
        }

    }).catch(() => {
        localStorage.setItem("cachedData", JSON.stringify(cached));
        window.alert("Data failed to submit. It has been cached and will be submitted later.");
        return false;
    });
}

export function submitCachedData() {
    const fetchRoute = endpoint + "/api/data/create";
    const cached = localStorage.getItem("cachedData") || "[]";
    const cachedData = JSON.parse(cached);
    
    fetch(fetchRoute, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Version": process.env.REACT_APP_VERSION || "0.0.0"
        },
        body: JSON.stringify(cachedData)
    }).then((res) => {
        if(res.status === 200) {
            localStorage.setItem("cachedData", "[]");
            window.alert("Data submitted successfully");
            return true;
        }
        localStorage.setItem("cachedData", JSON.stringify(cachedData));
        window.alert("Data failed to submit. It has been cached and will be submitted later.");
        return false;
    }).catch(() => {
        localStorage.setItem("cachedData", JSON.stringify(cachedData));
        window.alert("Data failed to submit. It has been cached and will be submitted later.");
        return false;
    });
}
